import { memo } from 'react';
import { useDispatch } from 'react-redux';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import styled from 'styled-components';
import { getBasesPuestoPublicas } from '../../../../../appStore/denominaciones';
import { ROLES } from '../../../../../const';
import { useConcurso } from '../../../../../providers/ConcursoProvider';
import LinkBtn from '../../../../CompUtils/LinkBtn';
import { useCheckRoles } from '../../../../hooks';
import { usePuestoTableConfig } from '../../../Gestion/TramitarConcursos/Commons/PuestosTable/PuestosTableProvider';
import { MenuOpcionesPuestoPublico } from './MenuOpcionesPuestoPublico';

export type PuestoProps = {
  idPuesto: number;
  ubicacionEstructural: string;
  denominacion: string;
  nivel: string;
  agrupamiento: string;
  reserva?: string;
  capacidadTerciaria?: string;
  funcionEspecifica: boolean;
  funcionEjecutiva: string;
  cantidad: number;
  pathPerfilPuesto: string;
  pathBbyccPuesto: string;
  requisitosCargados: boolean;
  idLlamadoConcurso: number;
};

type ColorTrProps = Partial<Record<'isComplete' | 'hasRequisitos' | 'hasPerfil', boolean>>;
const ColorTr = styled.tr<ColorTrProps>`
  color: 'blue';
  background-color: ${({ isComplete, hasPerfil, hasRequisitos }) =>
    isComplete
      ? 'lightgreen!important'
      : hasPerfil
      ? 'lightgoldenrodyellow!important'
      : hasRequisitos
      ? 'lightyellow!important'
      : undefined};
`;

export const PuestoRowPublico = memo((puesto: PuestoProps) => {
  const dispatch = useDispatch();
  const { onInscribirme } = usePuestoTableConfig();
  const esUser = useCheckRoles([ROLES.USER]);
  const { etapaLlamadoConcurso } = useConcurso();
  const {
    ubicacionEstructural,
    denominacion,
    nivel,
    agrupamiento,
    reserva,
    capacidadTerciaria,
    funcionEspecifica,
    cantidad,
    pathPerfilPuesto,
    pathBbyccPuesto,
    idPuesto,
  } = puesto;

  return (
    <>
      <ColorTr>
        {onInscribirme && esUser && etapaLlamadoConcurso.idEtapaLlamadoConcurso === 9 && (
          <td className="text-center align-middle">
            <LinkBtn
              transparent
              data-tip="Inscribirme al puesto"
              onClick={() => onInscribirme(puesto)}>
              <i className="fa fa-lg fa-edit text-success" />
            </LinkBtn>
          </td>
        )}

        <td className="align-middle">
          <ReactTooltip place="left" delayShow={1000} />
          {ubicacionEstructural}
        </td>
        <td className="align-middle">{denominacion}</td>
        <td className="text-center align-middle">{nivel}</td>
        <td className="align-middle text-center">{agrupamiento}</td>
        <td className="align-middle text-center">{reserva ? 'X' : ''}</td>
        <td className="align-middle text-center">{capacidadTerciaria ? 'X' : ''}</td>
        <td className="align-middle text-center">{funcionEspecifica ? 'X' : ''}</td>
        <td className="text-center align-middle">{cantidad}</td>

        <td className="text-center align-middle">
          <MenuOpcionesPuestoPublico idPuesto={idPuesto.toString()} pathPerfil={pathPerfilPuesto} />
        </td>

        <td className="text-center align-middle">
          <LinkBtn
            transparent
            data-tip="Generar bases y condiciones"
            onClick={() => {
              dispatch(getBasesPuestoPublicas({ idPuesto }));
            }}>
            <i className="fa fa-lg fa-file-text-o text-muted" />
          </LinkBtn>
        </td>
      </ColorTr>
    </>
  );
});
